import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toasty } from "@cloudflare/kumo/components/toast";
import { TooltipProvider } from "@cloudflare/kumo/components/tooltip";
import { LinkProvider } from "@cloudflare/kumo/utils";
import { App } from "./App";
import { AuthProvider } from "./auth";
import { initializeAnalytics } from "./analytics";
import { KumoRouterLink, RouterProvider } from "./router";
import { initializeTheme } from "./theme";
import "./styles.css";

initializeAnalytics();
document.documentElement.dataset.theme = "kumo";
initializeTheme();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <RouterProvider>
        <LinkProvider component={KumoRouterLink}>
          <TooltipProvider>
            <Toasty>
              <App />
            </Toasty>
          </TooltipProvider>
        </LinkProvider>
      </RouterProvider>
    </AuthProvider>
  </StrictMode>,
);
